import React from 'react';

import { useTranslation } from '@/config/i18n';


const ProfileTopHeader: React.FC = () => {
  const [t] = useTranslation('');

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title">
          {t('profile.title')}
        </h2>
      </div>
    </>
  );
};

export default ProfileTopHeader;
